// Realistic government form templates
export const formTemplates = {
  'health-schemes': {
    title: { 
      hindi: 'प्रधानमंत्री जन आरोग्य योजना (आयुष्मान भारत) आवेदन',
      english: 'Pradhan Mantri Jan Arogya Yojana (Ayushman Bharat) Application',
      marathi: 'प्रधानमंत्री जन आरोग्य योजना (आयुष्मान भारत) अर्ज',
      tamil: 'பிரதமர் ஜன் ஆரோக்ய யோஜனா (ஆயுஷ்மான் பாரத்) விண்ணப்பம்'
    },
    description: {
      hindi: 'यह योजना 5 लाख रुपये तक का मुफ्त स्वास्थ्य बीमा प्रदान करती है।',
      english: 'This scheme provides free health insurance coverage up to ₹5 lakh.',
      marathi: 'ही योजना 5 लाख रुपयांपर्यंत मोफत आरोग्य विमा प्रदान करते.',
      tamil: 'இந்த திட்டம் ₹5 லட்சம் வரை இலவச சுகாதார காப்பீட்டை வழங்குகிறது.'
    },
    formNumber: 'PMJAY-2025-',
    fields: [
      {
        id: 'applicant_name',
        label: { 
          hindi: 'आवेदक का पूरा नाम (जैसा कि आधार कार्ड में है)',
          english: "Applicant's Full Name (As per Aadhaar Card)",
          marathi: 'अर्जदाराचे पूर्ण नाव (आधार कार्डानुसार)',
          tamil: 'விண்ணப்பதாரர் முழு பெயர் (ஆதார் அட்டைப்படி)'
        },
        type: 'text',
        icon: '👤',
        required: true,
        validation: 'text',
        placeholder: { hindi: 'उदाहरण: राज कुमार शर्मा', english: 'e.g., Raj Kumar Sharma', marathi: 'उदा: राज कुमार शर्मा', tamil: 'எ.கா: ராஜ் குமார் சர்மா' }
      },
      {
        id: 'father_husband_name',
        label: {
          hindi: 'पिता/पति का नाम',
          english: "Father's/Husband's Name",
          marathi: 'वडील/पतीचे नाव',
          tamil: 'தந்தை/கணவர் பெயர்'
        },
        type: 'text',
        icon: '👨',
        required: true,
        placeholder: { hindi: 'उदाहरण: रामेश्वर शर्मा', english: 'e.g., Rameshwar Sharma', marathi: 'उदा: रामेश्वर शर्मा', tamil: 'எ.கா: ராமேஸ்வர் சர்மா' }
      },
      {
        id: 'date_of_birth',
        label: {
          hindi: 'जन्म तिथि (दिन/महीना/वर्ष)',
          english: 'Date of Birth (DD/MM/YYYY)',
          marathi: 'जन्म तारीख (दिन/महिना/वर्ष)',
          tamil: 'பிறந்த தேதி (நாள்/மாதம்/ஆண்டு)'
        },
        type: 'date',
        icon: '📅',
        required: true,
        placeholder: { hindi: '01/01/1990', english: '01/01/1990', marathi: '01/01/1990', tamil: '01/01/1990' }
      },
      {
        id: 'gender',
        label: {
          hindi: 'लिंग',
          english: 'Gender',
          marathi: 'लिंग',
          tamil: 'பாலினம்'
        },
        type: 'select',
        icon: '⚧',
        required: true,
        options: [
          { value: 'male', label: { hindi: 'पुरुष', english: 'Male', marathi: 'पुरुष', tamil: 'ஆண்' } },
          { value: 'female', label: { hindi: 'महिला', english: 'Female', marathi: 'स्त्री', tamil: 'பெண்' } },
          { value: 'other', label: { hindi: 'अन्य', english: 'Other', marathi: 'इतर', tamil: 'மற்றவை' } }
        ]
      },
      {
        id: 'mobile',
        label: {
          hindi: 'मोबाइल नंबर (10 अंक)',
          english: 'Mobile Number (10 digits)',
          marathi: 'मोबाइल नंबर (10 अंक)',
          tamil: 'மொபைல் எண் (10 இலக்கங்கள்)'
        },
        type: 'tel',
        icon: '📱',
        required: true,
        validation: 'mobile',
        placeholder: { hindi: '9876543210', english: '9876543210', marathi: '9876543210', tamil: '9876543210' }
      },
      {
        id: 'aadhaar',
        label: {
          hindi: 'आधार नंबर (12 अंक)',
          english: 'Aadhaar Number (12 digits)',
          marathi: 'आधार क्रमांक (12 अंक)',
          tamil: 'ஆதார் எண் (12 இலக்கங்கள்)'
        },
        type: 'text',
        icon: '🆔',
        required: true,
        validation: 'aadhaar',
        placeholder: { hindi: '1234 5678 9012', english: '1234 5678 9012', marathi: '1234 5678 9012', tamil: '1234 5678 9012' }
      },
      {
        id: 'address',
        label: {
          hindi: 'पूर्ण पता (मकान नंबर, गली, गांव/शहर)',
          english: 'Complete Address (House No., Street, Village/City)',
          marathi: 'पूर्ण पत्ता (घर क्रमांक, रस्ता, गाव/शहर)',
          tamil: 'முழு முகவரி (வீட்டு எண், தெரு, கிராமம்/நகரம்)'
        },
        type: 'textarea',
        icon: '🏠',
        required: true,
        placeholder: { hindi: 'उदाहरण: मकान नंबर 123, गांधी नगर, नई दिल्ली - 110001', english: 'e.g., House No. 123, Gandhi Nagar, New Delhi - 110001', marathi: 'उदा: घर क्रमांक 123, गांधी नगर, नवी दिल्ली - 110001', tamil: 'எ.கா: வீட்டு எண் 123, காந்தி நகர், புது டெல்லி - 110001' }
      },
      {
        id: 'state',
        label: {
          hindi: 'राज्य',
          english: 'State',
          marathi: 'राज्य',
          tamil: 'மாநிலம்'
        },
        type: 'select',
        icon: '🗺️',
        required: true,
        options: [
          { value: 'delhi', label: { hindi: 'दिल्ली', english: 'Delhi', marathi: 'दिल्ली', tamil: 'டெல்லி' } },
          { value: 'maharashtra', label: { hindi: 'महाराष्ट्र', english: 'Maharashtra', marathi: 'महाराष्ट्र', tamil: 'மகாராஷ்டிரா' } },
          { value: 'karnataka', label: { hindi: 'कर्नाटक', english: 'Karnataka', marathi: 'कर्नाटक', tamil: 'கர்நாடகா' } },
          { value: 'tamil_nadu', label: { hindi: 'तमिलनाडु', english: 'Tamil Nadu', marathi: 'तामिळनाडू', tamil: 'தமிழ்நாடு' } },
          { value: 'uttar_pradesh', label: { hindi: 'उत्तर प्रदेश', english: 'Uttar Pradesh', marathi: 'उत्तर प्रदेश', tamil: 'உத்தரபிரதேசம்' } }
        ]
      },
      {
        id: 'pincode',
        label: {
          hindi: 'पिन कोड (6 अंक)',
          english: 'PIN Code (6 digits)',
          marathi: 'पिन कोड (6 अंक)',
          tamil: 'பின் கோட் (6 இலக்கங்கள்)'
        },
        type: 'text',
        icon: '📮',
        required: true,
        validation: 'pincode',
        placeholder: { hindi: '110001', english: '110001', marathi: '110001', tamil: '110001' }
      },
      {
        id: 'ration_card',
        label: {
          hindi: 'राशन कार्ड का प्रकार',
          english: 'Type of Ration Card',
          marathi: 'रेशन कार्डचा प्रकार',
          tamil: 'ரேஷன் அட்டையின் வகை'
        },
        type: 'select',
        icon: '📋',
        required: true,
        options: [
          { value: 'apl', label: { hindi: 'APL (गरीबी रेखा से ऊपर)', english: 'APL (Above Poverty Line)', marathi: 'APL (दारिद्र्य रेषेच्या वर)', tamil: 'APL (வறுமைக் கோட்டிற்கு மேல்)' } },
          { value: 'bpl', label: { hindi: 'BPL (गरीबी रेखा से नीचे)', english: 'BPL (Below Poverty Line)', marathi: 'BPL (दारिद्र्य रेषेच्या खाली)', tamil: 'BPL (வறுமைக் கோட்டிற்கு கீழ்)' } },
          { value: 'antyodaya', label: { hindi: 'अंत्योदय', english: 'Antyodaya', marathi: 'अंत्योदय', tamil: 'அந்த்யோதயா' } },
          { value: 'none', label: { hindi: 'कोई नहीं', english: 'None', marathi: 'काहीही नाही', tamil: 'இல்லை' } }
        ]
      }
    ]
  },
  'farmer-schemes': {
    title: {
      hindi: 'प्रधानमंत्री किसान सम्मान निधि (PM-KISAN) पंजीकरण',
      english: 'Pradhan Mantri Kisan Samman Nidhi (PM-KISAN) Registration',
      marathi: 'प्रधानमंत्री किसान सन्मान निधि (PM-KISAN) नोंदणी',
      tamil: 'பிரதமர் கிசான் சம்மான் நிதி (PM-KISAN) பதிவு'
    },
    description: {
      hindi: '₹6000 प्रति वर्ष सीधे किसानों के बैंक खाते में',
      english: '₹6000 per year directly to farmers bank account',
      marathi: '₹6000 प्रतिवर्ष थेट शेतकर्‍यांच्या बँक खात्यात',
      tamil: 'ஆண்டுக்கு ₹6000 நேரடியாக விவசாயிகளின் வங்கிக் கணக்கில்'
    },
    formNumber: 'PMKISAN-2025-',
    fields: [
      {
        id: 'farmer_name',
        label: {
          hindi: 'किसान का पूरा नाम',
          english: "Farmer's Full Name",
          marathi: 'शेतकर्‍याचे पूर्ण नाव',
          tamil: 'விவசாயியின் முழு பெயர்'
        },
        type: 'text',
        icon: '👨‍🌾',
        required: true,
        placeholder: { hindi: 'उदाहरण: रामू पाटील', english: 'e.g., Ramu Patil', marathi: 'उदा: रामू पाटील', tamil: 'எ.கா: ராமு பாட்டீல்' }
      },
      {
        id: 'aadhaar',
        label: {
          hindi: 'आधार नंबर (12 अंक)',
          english: 'Aadhaar Number (12 digits)',
          marathi: 'आधार क्रमांक (12 अंक)',
          tamil: 'ஆதார் எண் (12 இலக்கங்கள்)'
        },
        type: 'text',
        icon: '🆔',
        required: true,
        validation: 'aadhaar',
        placeholder: { hindi: '1234 5678 9012', english: '1234 5678 9012', marathi: '1234 5678 9012', tamil: '1234 5678 9012' }
      },
      {
        id: 'mobile',
        label: {
          hindi: 'मोबाइल नंबर',
          english: 'Mobile Number',
          marathi: 'मोबाइल नंबर',
          tamil: 'மொபைல் எண்'
        },
        type: 'tel',
        icon: '📱',
        required: true,
        validation: 'mobile',
        placeholder: { hindi: '9876543210', english: '9876543210', marathi: '9876543210', tamil: '9876543210' }
      },
      {
        id: 'land_ownership',
        label: {
          hindi: 'भूमि स्वामित्व का प्रकार',
          english: 'Type of Land Ownership',
          marathi: 'जमीन मालकीचा प्रकार',
          tamil: 'நில உரிமையின் வகை'
        },
        type: 'select',
        icon: '📜',
        required: true,
        options: [
          { value: 'owned', label: { hindi: 'स्वयं की भूमि', english: 'Own Land', marathi: 'स्वतःची जमीन', tamil: 'சொந்த நிலம்' } },
          { value: 'leased', label: { hindi: 'पट्टे पर', english: 'Leased', marathi: 'भाडेतत्त्वावर', tamil: 'குத்தகை' } },
          { value: 'shared', label: { hindi: 'संयुक्त', english: 'Shared', marathi: 'संयुक्त', tamil: 'பகிர்ந்து' } }
        ]
      },
      {
        id: 'land_area',
        label: {
          hindi: 'भूमि का क्षेत्रफल (एकड़ में)',
          english: 'Land Area (in acres)',
          marathi: 'जमिनीचे क्षेत्रफळ (एकरमध्ये)',
          tamil: 'நிலத்தின் பரப்பளவு (ஏக்கரில்)'
        },
        type: 'number',
        icon: '🌾',
        required: true,
        placeholder: { hindi: 'उदाहरण: 2.5', english: 'e.g., 2.5', marathi: 'उदा: 2.5', tamil: 'எ.கா: 2.5' }
      },
      {
        id: 'land_survey_number',
        label: {
          hindi: 'भूमि का सर्वे/खसरा नंबर',
          english: 'Land Survey/Khasra Number',
          marathi: 'जमिनीचा सर्वे/खसरा क्रमांक',
          tamil: 'நில ஆய்வு/கஸ்ரா எண்'
        },
        type: 'text',
        icon: '🗃️',
        required: true,
        placeholder: { hindi: 'उदाहरण: 123/4', english: 'e.g., 123/4', marathi: 'उदा: 123/4', tamil: 'எ.கா: 123/4' }
      },
      {
        id: 'bank_account',
        label: {
          hindi: 'बैंक खाता संख्या',
          english: 'Bank Account Number',
          marathi: 'बँक खाते क्रमांक',
          tamil: 'வங்கி கணக்கு எண்'
        },
        type: 'text',
        icon: '🏦',
        required: true,
        placeholder: { hindi: '12345678901234', english: '12345678901234', marathi: '12345678901234', tamil: '12345678901234' }
      },
      {
        id: 'ifsc_code',
        label: {
          hindi: 'IFSC कोड',
          english: 'IFSC Code',
          marathi: 'IFSC कोड',
          tamil: 'IFSC குறியீடு'
        },
        type: 'text',
        icon: '🔢',
        required: true,
        placeholder: { hindi: 'उदाहरण: SBIN0001234', english: 'e.g., SBIN0001234', marathi: 'उदा: SBIN0001234', tamil: 'எ.கா: SBIN0001234' }
      },
      {
        id: 'village',
        label: {
          hindi: 'गांव/शहर का नाम',
          english: 'Village/City Name',
          marathi: 'गाव/शहराचे नाव',
          tamil: 'கிராமம்/நகரத்தின் பெயர்'
        },
        type: 'text',
        icon: '🏘️',
        required: true,
        placeholder: { hindi: 'उदाहरण: रामपुर', english: 'e.g., Rampur', marathi: 'उदा: रामपूर', tamil: 'எ.கா: ராம்பூர்' }
      },
      {
        id: 'district',
        label: {
          hindi: 'जिला',
          english: 'District',
          marathi: 'जिल्हा',
          tamil: 'மாவட்டம்'
        },
        type: 'text',
        icon: '🗺️',
        required: true,
        placeholder: { hindi: 'उदाहरण: मेरठ', english: 'e.g., Meerut', marathi: 'उदा: मेरठ', tamil: 'எ.கா: மீரட்' }
      }
    ]
  },
  'education-support': {
    title: {
      hindi: 'राष्ट्रीय छात्रवृत्ति पोर्टल आवेदन',
      english: 'National Scholarship Portal Application',
      marathi: 'राष्ट्रीय शिष्यवृत्ती पोर्टल अर्ज',
      tamil: 'தேசிய உதவித்தொகை போர்ட்டல் விண்ணப்பம்'
    },
    description: {
      hindi: 'छात्रों के लिए विभिन्न छात्रवृत्ति योजनाएं',
      english: 'Various scholarship schemes for students',
      marathi: 'विद्यार्थ्यांसाठी विविध शिष्यवृत्ती योजना',
      tamil: 'மாணவர்களுக்கான பல்வேறு உதவித்தொகை திட்டங்கள்'
    },
    formNumber: 'NSP-2025-',
    fields: [
      {
        id: 'student_name',
        label: {
          hindi: 'छात्र का पूरा नाम',
          english: "Student's Full Name",
          marathi: 'विद्यार्थ्याचे पूर्ण नाव',
          tamil: 'மாணவரின் முழு பெயர்'
        },
        type: 'text',
        icon: '🎓',
        required: true,
        placeholder: { hindi: 'उदाहरण: प्रिया शर्मा', english: 'e.g., Priya Sharma', marathi: 'उदा: प्रिया शर्मा', tamil: 'எ.கா: பிரியா சர்மா' }
      },
      {
        id: 'father_name',
        label: {
          hindi: 'पिता का नाम',
          english: "Father's Name",
          marathi: 'वडिलांचे नाव',
          tamil: 'தந்தையின் பெயர்'
        },
        type: 'text',
        icon: '👨',
        required: true,
        placeholder: { hindi: 'उदाहरण: राकेश शर्मा', english: 'e.g., Rakesh Sharma', marathi: 'उदा: राकेश शर्मा', tamil: 'எ.கா: ராகேஷ் சர்மா' }
      },
      {
        id: 'mother_name',
        label: {
          hindi: 'माता का नाम',
          english: "Mother's Name",
          marathi: 'आईचे नाव',
          tamil: 'தாயின் பெயர்'
        },
        type: 'text',
        icon: '👩',
        required: true,
        placeholder: { hindi: 'उदाहरण: सुनीता शर्मा', english: 'e.g., Sunita Sharma', marathi: 'उदा: सुनीता शर्मा', tamil: 'எ.கா: சுனிதா சர்மா' }
      },
      {
        id: 'date_of_birth',
        label: {
          hindi: 'जन्म तिथि',
          english: 'Date of Birth',
          marathi: 'जन्म तारीख',
          tamil: 'பிறந்த தேதி'
        },
        type: 'date',
        icon: '📅',
        required: true,
        placeholder: { hindi: '01/01/2005', english: '01/01/2005', marathi: '01/01/2005', tamil: '01/01/2005' }
      },
      {
        id: 'gender',
        label: {
          hindi: 'लिंग',
          english: 'Gender',
          marathi: 'लिंग',
          tamil: 'பாலினம்'
        },
        type: 'select',
        icon: '⚧',
        required: true,
        options: [
          { value: 'female', label: { hindi: 'महिला', english: 'Female', marathi: 'स्त्री', tamil: 'பெண்' } },
          { value: 'male', label: { hindi: 'पुरुष', english: 'Male', marathi: 'पुरुष', tamil: 'ஆண்' } },
          { value: 'other', label: { hindi: 'अन्य', english: 'Other', marathi: 'इतर', tamil: 'மற்றவை' } }
        ]
      },
      {
        id: 'category',
        label: {
          hindi: 'श्रेणी',
          english: 'Category',
          marathi: 'श्रेणी',
          tamil: 'வகை'
        },
        type: 'select',
        icon: '📊',
        required: true,
        options: [
          { value: 'general', label: { hindi: 'सामान्य', english: 'General', marathi: 'सामान्य', tamil: 'பொது' } },
          { value: 'obc', label: { hindi: 'OBC', english: 'OBC', marathi: 'OBC', tamil: 'OBC' } },
          { value: 'sc', label: { hindi: 'SC', english: 'SC', marathi: 'SC', tamil: 'SC' } },
          { value: 'st', label: { hindi: 'ST', english: 'ST', marathi: 'ST', tamil: 'ST' } }
        ]
      },
      {
        id: 'mobile',
        label: {
          hindi: 'मोबाइल नंबर',
          english: 'Mobile Number',
          marathi: 'मोबाइल नंबर',
          tamil: 'மொபைல் எண்'
        },
        type: 'tel',
        icon: '📱',
        required: true,
        validation: 'mobile',
        placeholder: { hindi: '9876543210', english: '9876543210', marathi: '9876543210', tamil: '9876543210' }
      },
      {
        id: 'email',
        label: {
          hindi: 'ईमेल आईडी (यदि उपलब्ध हो)',
          english: 'Email ID (if available)',
          marathi: 'ईमेल आयडी (उपलब्ध असल्यास)',
          tamil: 'மின்னஞ்சல் ஐடி (இருந்தால்)'
        },
        type: 'email',
        icon: '📧',
        required: false,
        placeholder: { hindi: 'उदाहरण: student@email.com', english: 'e.g., student@email.com', marathi: 'उदा: student@email.com', tamil: 'எ.கா: student@email.com' }
      },
      {
        id: 'class_studying',
        label: {
          hindi: 'वर्तमान में पढ़ रहे कक्षा/कोर्स',
          english: 'Currently Studying Class/Course',
          marathi: 'सध्या शिकत असलेला वर्ग/अभ्यासक्रम',
          tamil: 'தற்போது படிக்கும் வகுப்பு/பாடநெறி'
        },
        type: 'text',
        icon: '📚',
        required: true,
        placeholder: { hindi: 'उदाहरण: 10वीं कक्षा या B.Tech प्रथम वर्ष', english: 'e.g., 10th Standard or B.Tech First Year', marathi: 'उदा: 10वी इयत्ता किंवा B.Tech प्रथम वर्ष', tamil: 'எ.கா: 10வது வகுப்பு அல்லது B.Tech முதல் ஆண்டு' }
      },
      {
        id: 'school_name',
        label: {
          hindi: 'स्कूल/कॉलेज का नाम',
          english: 'School/College Name',
          marathi: 'शाळा/महाविद्यालयाचे नाव',
          tamil: 'பள்ளி/கல்லூரி பெயர்'
        },
        type: 'text',
        icon: '🏫',
        required: true,
        placeholder: { hindi: 'उदाहरण: राजकीय उच्च विद्यालय', english: 'e.g., Government High School', marathi: 'उदा: राज्य उच्च विद्यालय', tamil: 'எ.கா: அரசு மேல்நிலைப் பள்ளி' }
      },
      {
        id: 'board_university',
        label: {
          hindi: 'बोर्ड/विश्वविद्यालय',
          english: 'Board/University',
          marathi: 'बोर्ड/विद्यापीठ',
          tamil: 'வாரியம்/பல்கலைக்கழகம்'
        },
        type: 'text',
        icon: '🎯',
        required: true,
        placeholder: { hindi: 'उदाहरण: CBSE या Delhi University', english: 'e.g., CBSE or Delhi University', marathi: 'उदा: CBSE किंवा दिल्ली विद्यापीठ', tamil: 'எ.கா: CBSE அல்லது Delhi University' }
      },
      {
        id: 'previous_marks',
        label: {
          hindi: 'पिछली परीक्षा में प्राप्त प्रतिशत',
          english: 'Percentage in Previous Exam',
          marathi: 'मागील परीक्षेत मिळालेली टक्केवारी',
          tamil: 'முந்தைய தேர்வில் பெற்ற சதவீதம்'
        },
        type: 'number',
        icon: '📊',
        required: true,
        placeholder: { hindi: 'उदाहरण: 85.5', english: 'e.g., 85.5', marathi: 'उदा: 85.5', tamil: 'எ.கா: 85.5' }
      },
      {
        id: 'annual_income',
        label: {
          hindi: 'परिवार की वार्षिक आय (रुपये में)',
          english: 'Annual Family Income (in Rupees)',
          marathi: 'कुटुंबाचे वार्षिक उत्पन्न (रुपयात)',
          tamil: 'குடும்பத்தின் ஆண்டு வருமானம் (ரூபாயில்)'
        },
        type: 'number',
        icon: '💰',
        required: true,
        placeholder: { hindi: 'उदाहरण: 100000', english: 'e.g., 100000', marathi: 'उदा: 100000', tamil: 'எ.கா: 100000' }
      },
      {
        id: 'bank_account',
        label: {
          hindi: 'बैंक खाता संख्या (छात्र के नाम पर)',
          english: 'Bank Account Number (In Student Name)',
          marathi: 'बँक खाते क्रमांक (विद्यार्थ्याच्या नावावर)',
          tamil: 'வங்கி கணக்கு எண் (மாணவர் பெயரில்)'
        },
        type: 'text',
        icon: '🏦',
        required: true,
        placeholder: { hindi: '12345678901234', english: '12345678901234', marathi: '12345678901234', tamil: '12345678901234' }
      },
      {
        id: 'ifsc_code',
        label: {
          hindi: 'IFSC कोड',
          english: 'IFSC Code',
          marathi: 'IFSC कोड',
          tamil: 'IFSC குறியீடு'
        },
        type: 'text',
        icon: '🔢',
        required: true,
        placeholder: { hindi: 'उदाहरण: SBIN0001234', english: 'e.g., SBIN0001234', marathi: 'उदा: SBIN0001234', tamil: 'எ.கா: SBIN0001234' }
      }
    ]
  }
};